import { styled, Typography } from '@mui/material';

export const EditorialMedia = styled('section')(() => ({
  position: 'relative',
  width: '100%',
  textAlign: 'center',
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '120px',
  lineHeight: 1.2,
  color: theme.palette.color.grey.light20,

  [theme.breakpoints.down('2xl')]: {
    fontSize: '104px',
  },
  [theme.breakpoints.down('xl')]: {
    fontSize: '88px',
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: '72px',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '52px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '44px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '44px',
  },
}));

export const Bottom = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '72px',
  maxWidth: '1148px',
  margin: '0 auto',

  [theme.breakpoints.down('2xl')]: {
    gap: '44px',
  },
  [theme.breakpoints.down('lg')]: {
    gap: '40px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '36px',
  },
  [theme.breakpoints.down('sm')]: {
    gap: '32px',
  },
}));

export const Imgs = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  gap: '12px',
  width: '100%',

  [theme.breakpoints.down('2xl')]: {
    gap: '8px',
  },
  [theme.breakpoints.down('sm')]: {
    width: 'calc(100% + 32px)',
    gap: 0,
  },
}));

export const Img = styled('img')(({ theme }) => ({
  height: '100%',

  '&:first-of-type': {
    width: '35.89%',

    [theme.breakpoints.down('2xl')]: {
      width: '24.042%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '47%',
    },
  },
  '&:last-of-type': {
    width: '39.38%',
    marginTop: '-60px',

    [theme.breakpoints.down('2xl')]: {
      width: '26.133%',
      marginTop: '-50px',
    },
    [theme.breakpoints.down('xl')]: {
      marginTop: '-42px',
    },
    [theme.breakpoints.down('lg')]: {
      marginTop: '-34px',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: '-20px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '51.75%',
    },
  },
}));
